import { IStructuralTransformer } from './StructuralTransformer.js';
import { SourcedValueOptions } from '../../option.js';

export class IdentityStructuralTransformer implements IStructuralTransformer<SourcedValueOptions> {
  transform(sourcedValueOptions: SourcedValueOptions): SourcedValueOptions {
    return sourcedValueOptions;
  }
}
